import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { environment } from '~environment';
import { selectAuthToken } from '~login/store/login.selectors';
import { jwtDecode } from 'jwt-decode';

export type LoginReasonsType = 'InvalidUsernameOrPassword' | 'CustomerIsDisabled' | 'UserIsLockedOut';
export interface LoginResponse {
    readonly token?: string;
    readonly reason?: LoginReasonsType;
}

@Injectable({
    providedIn: 'root',
})
export class LoginService {
    private readonly http = inject(HttpClient);
    private readonly store = inject(Store);
    private readonly url: string = environment.serverBaseUrl + 'auth/login';

    Login(email: string, password: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(this.url, { email, password });
    }

    parseToken = (token: string | null): unknown | null => {
        if (token === null) {
            return null;
        }

        try {
            return jwtDecode<unknown>(token);
        } catch (_e) {
            return null;
        }
    };

    isTokenExpired = (token: any): boolean => token.exp * 1000 < Date.now();

    getToken(): string | null {
        let token: string | null =  localStorage.getItem('token');
        if (token === null) {
            this.store
                .select(selectAuthToken)
                .pipe(take(1))
                .subscribe((tokenValue: string | null): void => {
                    token = tokenValue;
                });
        }
        return token;
    }

    isLoggedIn(): boolean {
        const parsedToken = this.parseToken(this.getToken());
        return parsedToken !== null && !this.isTokenExpired(parsedToken!);
    }
}
